// 意见反馈

export default [
    {
        path: '/feedback/index',
        component: () =>
            import ('../../pages/feedback/index.vue'),
        meta: {
            keepAlive: true,
            title: '意见反馈'
        }
    },
    {
        path: '/feedback/feedback',
        component: () =>
            import ('../../pages/feedback/feedback.vue'),
        meta: {
            keepAlive: false,
            title: '意见反馈'
        }
    },
    {
        path: '/feedback/myFeedback',
        component: () =>
            import ('../../pages/feedback/myFeedback.vue'),
        meta: {
            keepAlive: false,
            title: '我的反馈'
        }
    },
    {
        path: '/feedback/feedbackDetail/:isAdmin',
        component: () =>
            import ('../../pages/feedback/feedbackDetail.vue'),
        meta: {
            keepAlive: false,
            title: '反馈详情'
        }
    },
    {
        path: '/myFeedback',
        component: () =>
            import ('../../pages/feedback/myFeedback.vue'),
        meta: {
            keepAlive: false,
            title: '意见反馈'
        }
    },
    {
        path: '/previewVideo',
        component: () =>
            import ('../../pages/feedback/components/popupVideo'),
        meta: {
            keepAlive: false,
            title: '意见反馈'
        }
    }
]